import {AppScreen} from 'services/analytics';

export function createPayload(): OpenHistoryEventPayload {
  return {source: AppScreen.Main};
}
